import React, {useEffect, useRef, useState} from 'react';
import './FactionPurchaseRewardModal.css';
import {COLORS_CONFIG, PLAYER_COLORS} from '../../../configs/colors';
import PageButton from "../../elements/PageButton/PageButton";
import FactionCardOverlay from "../../FactionCardOverlay/FactionCardOverlay";
import {getFactionConfig} from "../../../utils/factions/getFactionConfig";
import {getFactionImagePath} from "../../../utils/factions/getFactionImagePath";
import {MENU_SOUND_MANAGER} from "../../../scenes/MenuSoundManager";

const PAGE_ID = 'FactionPurchaseRewardModal';

function FactionPurchaseRewardModal({factionId, onClaim, onEntered}) {
  const [visible, setVisible] = useState(false);
  // «Подробно» — карточка фракции (FactionCardOverlay) поверх модалки;
  // закрытие карточки возвращает к модалке
  const [showDetails, setShowDetails] = useState(false);
  const enteredRef = useRef(false);

  const factionConfig = getFactionConfig(factionId);
  const resolveFactionColor = (colorKey, fallbackColor) => {
    if (colorKey === PLAYER_COLORS.BROWN) return '#7b3c00';
    if (colorKey === PLAYER_COLORS.BLUE) return '#157be0';
    return COLORS_CONFIG[colorKey] || fallbackColor;
  };
  const factionColor = resolveFactionColor(factionConfig?.colors?.[0], factionConfig?.textColor);
  const factionName = factionConfig?.name || factionId;

  useEffect(() => {
    const soundManager = MENU_SOUND_MANAGER;
    if (soundManager?.playFactionSelect && factionId) {
      soundManager.playFactionSelect(factionId);
    }

    const showTimer = setTimeout(() => setVisible(true), 50);
    return () => clearTimeout(showTimer);
  }, [factionId]);

  const handleClaim = () => {
    setVisible(false);
    setTimeout(() => {
      onClaim?.();
    }, 300);
  };

  const handleOverlayClick = (event) => {
    if (event.target === event.currentTarget) {
      handleClaim();
    }
  };

  const handleTransitionEnd = (event) => {
    if (event.target !== event.currentTarget) return;
    if (event.propertyName !== 'opacity') return;
    if (visible && !enteredRef.current) {
      enteredRef.current = true;
      onEntered?.();
    }
  };

  if (!factionConfig) return null;

  return (
    <div
      className={`faction-purchase-reward-overlay ${visible ? 'faction-purchase-reward-overlay_visible' : ''}`}
      onClick={handleOverlayClick}
      onTransitionEnd={handleTransitionEnd}
      role="dialog"
      aria-modal="true"
    >
      <div
        className={`faction-purchase-reward-modal ${visible ? 'faction-purchase-reward-modal_visible' : ''}`}
        style={{'--faction-color': factionColor}}
      >
        <div className="faction-purchase-reward-content">
          <div className="faction-purchase-reward-image-wrapper">
            <img
              className="faction-purchase-reward-image"
              src={getFactionImagePath(factionId)}
              alt={factionName}
            />
          </div>
          <div className="faction-purchase-reward-info">
            <h2 className="faction-purchase-reward-name" style={{color: factionColor}}>
              {factionName}
            </h2>
            <span className="faction-purchase-reward-title">Новая фракция доступна!</span>
          </div>

          <div className="main-menu-buttons faction-purchase-reward-buttons">
            <PageButton
              className="main-menu-button_secondary"
              onClick={() => setShowDetails(true)}
              pageId={PAGE_ID}
              buttonId="faction_details"
            >
              Подробно
            </PageButton>

            <PageButton onClick={handleClaim} pageId={PAGE_ID} buttonId="claim_reward">
              Отлично!
            </PageButton>
          </div>
        </div>
      </div>

      {showDetails && (
        <FactionCardOverlay
          factionId={factionId}
          onClose={() => setShowDetails(false)}
        />
      )}
    </div>
  );
}

export default FactionPurchaseRewardModal;
